// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__27hHj","field":"styles_field__2DrJo","fieldCol":"styles_fieldCol__24nrt","diffCol":"styles_diffCol__1LaX2","diff":"styles_diff__3kyrn"};